import React from "react";

// Opening block of the services sections: small label, serif title, optional text below
const SectionIntro: React.FC<Props> = ({eyebrow, title, titleColor, children}) => {
  return (
    <div className="max-w-[640px] mx-auto px-8 text-center">
      <p className="mb-3.5 text-3xs font-medium tracking-[.3em] uppercase text-white/60">{eyebrow}</p>
      <h2 className={`font-serif font-medium text-[34px] 2xl:text-5xl leading-[1.12] ${titleColor}`}>{title}</h2>
      {children}
    </div>
  );
};

export default SectionIntro;

interface Props {
  eyebrow: string,
  title: React.ReactNode,
  titleColor: 'text-quaternary' | 'text-accentWoman',
  children?: React.ReactNode
}
